"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var react_uid_1 = require("react-uid");
var modal_1 = __importDefault(require("@prezzee/modal"));
var fade_1 = __importDefault(require("@prezzee/fade"));
var paper_1 = __importDefault(require("@prezzee/paper"));
// import Backdrop from '@prezzee/backdrop';
var DialogContext_1 = __importDefault(require("./DialogContext"));
var theme_1 = require("@prezzee/theme");
var style = __importStar(require("./Dialog.style"));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */
var Dialog = (0, react_1.forwardRef)(function (props, ref) {
    var theme = (0, theme_1.useTheme)();
    var defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen,
    };
    var ariaDescribedby = props["aria-describedby"], ariaLabelledbyProp = props["aria-labelledby"], 
    // BackdropComponent,
    // BackdropProps,
    children = props.children, className = props.className, _a = props.disableEscapeKeyDown, disableEscapeKeyDown = _a === void 0 ? false : _a, _b = props.fullScreen, fullScreen = _b === void 0 ? false : _b, _c = props.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = props.maxWidth, maxWidth = _d === void 0 ? 'sm' : _d, onClose = props.onClose, open = props.open, _e = props.PaperComponent, PaperComponent = _e === void 0 ? paper_1.default : _e, _f = props.PaperProps, PaperProps = _f === void 0 ? {} : _f, _g = props.scroll, scroll = _g === void 0 ? 'paper' : _g, _h = props.TransitionComponent, TransitionComponent = _h === void 0 ? fade_1.default : _h, _j = props.transitionDuration, transitionDuration = _j === void 0 ? defaultTransitionDuration : _j, TransitionProps = props.TransitionProps, other = __rest(props, ['aria-describedby', 'aria-labelledby', "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"]);
    var ownerState = __assign(__assign({}, props), { disableEscapeKeyDown: disableEscapeKeyDown, fullScreen: fullScreen, fullWidth: fullWidth, maxWidth: maxWidth, scroll: scroll });
    var backdropClick = (0, react_1.useRef)();
    var handleMouseDown = function (event) {
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    var handleBackdropClick = function (event) {
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) {
            return;
        }
        backdropClick.current = null;
        if (onClose) {
            onClose(event, 'backdropClick');
        }
    };
    var uid = (0, react_uid_1.useUID)();
    var ariaLabelledby = ariaLabelledbyProp || 'dialog-' + uid;
    var dialogContextValue = (0, react_1.useMemo)(function () {
        return { titleId: ariaLabelledby };
    }, [ariaLabelledby]);
    return ((0, jsx_runtime_1.jsx)(modal_1.default, __assign({ className: className, 
        // BackdropProps={{
        //   transitionDuration,
        //   // as: BackdropComponent,
        //   // ...BackdropProps,
        // }}
        closeAfterTransition: true, 
        // BackdropComponent={Backdrop}
        disableEscapeKeyDown: disableEscapeKeyDown, onClose: onClose, open: open, ref: ref, onClick: handleBackdropClick }, other, { children: (0, jsx_runtime_1.jsx)(TransitionComponent, __assign({ appear: true, in: open, timeout: transitionDuration, role: "presentation" }, TransitionProps, { children: (0, jsx_runtime_1.jsx)("div", __assign({ onMouseDown: handleMouseDown, css: style.container(ownerState) }, { children: (0, jsx_runtime_1.jsx)(PaperComponent, __assign({ elevation: "xl", role: "dialog", "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledby }, PaperProps, { className: PaperProps.className, css: style.paper(ownerState) }, { children: (0, jsx_runtime_1.jsx)(DialogContext_1.default.Provider, __assign({ value: dialogContextValue }, { children: children })) })) })) })) })));
});
Dialog.displayName = 'PrezzeeDialog';
exports.default = Dialog;
//# sourceMappingURL=Dialog.js.map